import * as P from 'plow-js';
import { handleActions } from 'redux-actions';
// feature router
import {
  setPageNameRoutine,
  setCurrentRouteRoutine,
} from './routines';
//////////////////////////////////////////////////

export const initialState = {
  pageName: '',
  currentRoute: '',
};

const setPageName = (state, { payload }) => P.$set('pageName', payload, state);

const setCurrentRoute = (state, { payload }) => P.$set('currentRoute', payload, state);

export default handleActions({
  [setPageNameRoutine.TRIGGER]: setPageName,
  [setCurrentRouteRoutine.TRIGGER]: setCurrentRoute,
}, initialState);
